import { render, staticRenderFns } from "./ProducerCommissionForm.vue?vue&type=template&id=3c46797c&scoped=true"
import script from "./ProducerCommissionForm.vue?vue&type=script&lang=js"
export * from "./ProducerCommissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46797c",
  null
  
)

export default component.exports